export { default } from './ProviderLanguages';
